export const isSerializedInventoryRow = rowData =>
	rowData?.is_serialized === true ||
	['si', 'sí'].includes(String(rowData?.is_serialized || '').toLowerCase());

export const canEditSerializedState = ({
	rowData,
	isTransactionFrozen = false,
} = {}) =>
	!isTransactionFrozen && isSerializedInventoryRow(rowData) && !!rowData?.wtdi_id;
